module.exports = __webpack_public_path__ + "img/10_thiem.10c375ce.jpg";